import request, { post, get } from '@/utils/request'
import { ouchnCustom } from '../../service'

const urlGetCartList = ouchnCustom + '/web/api/ocShoppingCart/list'
const urlDeleteCartItem = ouchnCustom + '/web/api/ocShoppingCart/deleteById'
const urlBatDeleteCartItems = ouchnCustom + '/web/api/ocShoppingCart/deleteByIds'
// const url = ouchnCustom + ''

// 获取用户购物车列表
export const apiGetCartList = (data) => get(urlGetCartList, data)

export const apiDeleteCartItem = (params) => {
  return request({
    url: urlDeleteCartItem,
    method: 'delete',
    params,
  })
}

export const apiBatDeleteCartItems = (params) => {
  return request({
    url: urlBatDeleteCartItems,
    method: 'delete',
    params,
  })
}
//获取支付宝二维码链接
export function aliCode(orderNumber) {
  return request({
    url: ouchnCustom + '/web/aliPay/toPayAsPC?orderNumber=' + orderNumber,
    // url:'https://pay.ouchn.airlib.com/web/aliPay/toPayAsPC?orderNumber='+orderNumber,
    method: 'get',
    isFocusPassCode: true,
  })
}
//获取微信二维码链接
export function wxCode(orderNumber) {
  return request({
    url: ouchnCustom + '/web/wxPay/wechatPayV3?orderNumber=' + orderNumber,
    // url:'https://pay.ouchn.airlib.com/web/wxPay/wechatPayV3?orderNumber='+orderNumber,
    method: 'get',
  })
}
// 支付宝订单查询
export function aliOrderQuery(orderNumber) {
  return request({
    url: ouchnCustom + '/web/aliPay/queryOrderV3?orderNumber=' + orderNumber,
    // url:'https://pay.ouchn.airlib.com/web/aliPay/queryOrderV3?orderNumber='+orderNumber,
    method: 'get',
    isSilence: true,
  })
}
//微信订单查询
export function wxOrderQuery(orderNumber, type) {
  return request({
    url: ouchnCustom + '/web/wxPay/queryOrderV3?orderNumber=' + orderNumber + '&type=' + type,
    // url:'https://pay.ouchn.airlib.com/web/wxPay/queryOrderV3?orderNumber='+orderNumber,
    method: 'get',
    isSilence: true,
  })
}
